import { useState } from "react";
import { Plus } from "lucide-react";
import NewSaleModal from "../modals/NewSaleModal";
import { dictionary, Language } from "../../utils/dictionary";
import { useAuth } from "../../context/AuthContext";
// import { useCurrency } from "../../context/Currency";

const SalesHeader = () => {
  const [isNewSaleModalOpen, setIsNewSaleModalOpen] = useState(false);
  const { language } = useAuth();
  // const { isDollar, setIsDollar } = useCurrency();
  // const { setFilter, filter } = useSalesStore();

  return (
    <div className="flex flex-col space-y-4 mb-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">{dictionary["sales-orders"][language]}</h1>
        {/* <div className="flex justify-end">
          <button className="bg-blue-500 text-white px-4 py-2 rounded-md" onClick={() => setIsDollar(!isDollar)}>{dictionary["change-currency"][language]}</button>
        </div> */}
        {/* <div className="flex items-center space-x-3"> */}
          {/* <button
            // onClick={() => setIsNewSaleModalOpen(true)}
            className="px-4 py-2 text-white rounded-lg flex items-center space-x-2 opacity-50 cursor-not-allowed"
            style={{
              background: "#bab9b9",
              // "linear-gradient(90deg, rgb(107, 107, 126) 0%, rgb(70, 70, 70) 100%)",
            }}
          >
            <Plus size={20} />
            <span>Registrar nueva venta</span>
          </button> */}
          {/* <button
            className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
            title="Importar"
          >
            <Upload size={20} />
          </button>
          <button
            className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
            title="Exportar"
          >
            <Download size={20} />
          </button> */}
        {/* </div> */}
      </div>

      {/* <div className="flex items-center space-x-4">
        <button
          onClick={() => setFilter(filter === "Chat" ? null : "Chat")}
          className={`px-4 py-2 rounded-lg ${
            filter === "Chat"
              ? "bg-[#4D88FF] text-white"
              : "bg-white border border-gray-200 hover:bg-gray-50"
          }`}
        >
          Ventas Chat
        </button>
        <button
          onClick={() => setFilter(filter === "Web" ? null : "Web")}
          className={`px-4 py-2 rounded-lg ${
            filter === "Web"
              ? "bg-[#4D88FF] text-white"
              : "bg-white border border-gray-200 hover:bg-gray-50"
          }`}
        >
          Ventas Página Web
        </button>
        <button
          onClick={() => setFilter(filter === "Manual" ? null : "Manual")}
          className={`px-4 py-2 rounded-lg ${
            filter === "Manual"
              ? "bg-[#4D88FF] text-white"
              : "bg-white border border-gray-200 hover:bg-gray-50"
          }`}
        >
          Ventas creadas manualmente
        </button>
        <button className="px-4 py-2 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 flex items-center space-x-2">
          <Filter size={16} />
          <span>Todos</span>
        </button>
      </div> */}

      <NewSaleModal
        isOpen={isNewSaleModalOpen}
        onClose={() => setIsNewSaleModalOpen(false)}
      />
    </div>
  );
};

export default SalesHeader;
